import { Offer, SeatMap } from "@duffel/api/types";
import { hasAvailableSeatService } from "../lib/hasAvailableSeatService";

export function hasService(offer: Offer, seatMaps?: SeatMap[]) {
  const offerHasService =
    offer &&
    Array.isArray(offer.available_services) &&
    offer.available_services.some((service) => service.maximum_quantity > 0);

  return offerHasService || hasAvailableSeatService(seatMaps);
}
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";